import { render, staticRenderFns } from "./ViewToggle.vue?vue&type=template&id=df2150e0"
import script from "./ViewToggle.vue?vue&type=script&lang=js"
export * from "./ViewToggle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports